import { useImmer } from "use-immer";
import { useEffect } from "react";
import UtilService from "../../service/UtilService";

const Component = ({ successStatistic }) => {
  const [data, updateData] = useImmer(null);

  useEffect(() => {
    updateData(successStatistic);
  }, [successStatistic]);

  return (
    <>
      {data && (
        <table className="config-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Confirmed frauds</td>
              <td>{data.totalFrauds}</td>
            </tr>
            <tr>
              <td>True positives</td>
              <td>{data.truePositives}</td>
            </tr>
            <tr>
              <td>False positives</td>
              <td>{data.falsePositives}</td>
            </tr>
            <tr>
              <td>Effective frauds</td>
              <td>{data.totalEffectiveFrauds}</td>
            </tr>
            <tr>
              <td>Effective true positives</td>
              <td>{data.effectiveTruePositives}</td>
            </tr>
            <tr>
              <td>Effective false positives</td>
              <td>{data.effectiveFalsePositives}</td>
            </tr>
          </tbody>
        </table>
      )}
    </>
  );
};

export default Component;
